import { Logging, UserInfo, PermissionGroup } from '@vcd-ecm-ui/Common';
import {
  USER_INFO_REQUESTED,
  USER_INFO_REQUEST_SUCCEEDED,
  USER_INFO_REQUEST_FAILED,
} from './user-hook-action-types';
import AsyncThunkCreator from '../../../shared-types/AsyncThunkCreator.type';

export const getUserInfo = (): AsyncThunkCreator => async (
  dispatch, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  getState, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  api, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
): Promise<void> => {
  // // Prevent duplicate Requests on Startup
  if (getState()?.user?.userInfoRequested === false) {
    // Set Flag to prevent multiple requests
    dispatch({ type: USER_INFO_REQUESTED });

    try {
      const userInfo: UserInfo = await api.user.getUserInfoV4();

      // Override the Permissions for the UI here
      // userInfo.permissions[PermissionGroup.ECWizard] = { create: true, edit: true, view: true };

      Logging.Info('Getting User Info:', userInfo);

      dispatch({
        type: USER_INFO_REQUEST_SUCCEEDED,
        payload: { userInfo },
      });
    } catch (e) {
      dispatch({ type: USER_INFO_REQUEST_FAILED, error: e.message });
    }
  }
};

export default { getUserInfo }; /* eslint-disable-line semi */
